import {DateTime} from "luxon";
import {Subscription} from "../../services/subscription-service";
import {SubscriptionTypeValues} from "../../api/generated/herds-licensing";

export type SubscriptionStatus = 'trial' | 'active' | 'cancelledAtEnd' | 'cancelled' | 'expired';

type StatusInput = {
    subscription: Pick<Subscription, 'cancelledAt' | 'isExpired' | 'type'>,
    creemActive: boolean,
    now?: DateTime,
};

/**
 * Derives the status chips for a subscription. Returns a list because an expired
 * subscription that was cancelled additionally shows the "cancelled" chip.
 * A local trial (type TRIAL without active Creem subscription) is distinguished from a paid one.
 */
export const getSubscriptionStatuses = ({subscription, creemActive, now = DateTime.now()}: StatusInput): SubscriptionStatus[] => {
    const {cancelledAt, isExpired, type} = subscription;
    const isCancelled = !!cancelledAt?.isValid;

    if (isExpired) {
        return isCancelled ? ['expired', 'cancelled'] : ['expired'];
    }
    if (isCancelled) {
        return cancelledAt <= now ? ['cancelled'] : ['cancelledAtEnd'];
    }
    if (type === SubscriptionTypeValues.TRIAL && !creemActive) {
        return ['trial'];
    }
    return ['active'];
};
